import React, { useEffect, useState, Fragment } from 'react';
interface ProductCard {
  icon: string;
  dotColor: string;
  bookColor: string;
  label: string;
  title: string;
  description: string;
}
const PRODUCTS: ProductCard[] = [{
  icon: '📘',
  dotColor: 'bg-orange-500',
  bookColor: 'from-orange-600 to-orange-800',
  label: 'TOMO 1',
  title: 'La Ingeniería de la Masa',
  description: 'Fórmula exacta, test de elasticidad, colorimetría artesanal y todas las formas: varillas, conitos, peluditos, bicolor y negros. Incluye guía de secado y checklist de errores.'
}, {
  icon: '📗',
  dotColor: 'bg-purple-500',
  bookColor: 'from-purple-600 to-purple-800',
  label: 'TOMO 2',
  title: 'Alquimia y Aromaterapia',
  description: 'Método de doble infusión para fijar aromas, mezclas funcionales por intención y la línea completa de sahumerios zodiacales.'
}, {
  icon: '📕',
  dotColor: 'bg-red-500',
  bookColor: 'from-red-600 to-red-800',
  label: 'TOMO 3',
  title: 'Negocio y Ventas 2026',
  description: 'Costos y precios en pesos 2026, packaging que vende, estrategia para WhatsApp, Instagram y Marketplace, y cálculo de punto de equilibrio.'
}, {
  icon: '🥇',
  dotColor: 'bg-amber-500',
  bookColor: 'from-amber-500 to-amber-700',
  label: 'BONO 1',
  title: 'Reto de los 30 Días',
  description: 'Mapa de ruta diario: desde comprar los insumos hasta cobrar tu primera venta. Día por día, sin improvisación.'
}, {
  icon: '🥈',
  dotColor: 'bg-stone-400',
  bookColor: 'from-stone-500 to-stone-700',
  label: 'BONO 2',
  title: 'Manual de Seguridad y Calidad',
  description: 'El checklist profesional: evitá que se apaguen, se quiebren o pierdan aroma. Control de procesos para calidad constante.'
}];
function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 2,
    minutes: 47,
    seconds: 33
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(t => {
        let {
          hours,
          minutes,
          seconds
        } = t;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 font-mono" data-id="element-55">
      {[{
      label: 'HS',
      value: pad(time.hours)
    }, {
      label: 'MIN',
      value: pad(time.minutes)
    }, {
      label: 'SEG',
      value: pad(time.seconds)
    }].map((unit, i) => <Fragment key={unit.label} data-id="element-56">
          <div className="flex flex-col items-center bg-amber-950 text-white rounded-lg px-3 py-2 min-w-[52px] shadow-inner" data-id="element-57">
            <span className="text-2xl font-extrabold tabular-nums leading-none" data-id="element-58">
              {unit.value}
            </span>
            <span className="text-[9px] font-bold tracking-widest text-amber-300/80 mt-1" data-id="element-59">
              {unit.label}
            </span>
          </div>
          {i < 2 && <span className="text-amber-950 font-bold text-xl" data-id="element-60">:</span>}
        </Fragment>)}
    </div>;
}
function BookStack() {
  return <div className="relative w-full mx-auto flex items-end justify-center px-2 pt-2 pb-1" data-id="element-61">
      {/* Soft glow behind */}
      <div className="absolute inset-x-8 bottom-2 h-8 bg-amber-900/25 blur-2xl rounded-full" data-id="element-62" />

      {/* 3 main tomos in front + 2 bonuses behind/sides */}
      <div className="relative flex items-end justify-center gap-1.5 z-10" data-id="element-63">
        {/* Bono 1 — tucked behind left */}
        <div className="absolute -left-3 bottom-4 w-[60px] h-[108px] rounded-md shadow-lg transform -rotate-[14deg] overflow-hidden border border-amber-900/30 ring-1 ring-black/10" style={{
        zIndex: 1
      }} data-id="element-64">
          <img src="https://cdn.magicpatterns.com/uploads/tVAnUEHb2BgYbPU4Xk7iwL/BONO_1_-_sahumerios.png" alt="Bono 1 — Reto de los 30 Días" className="w-full h-full object-cover" data-id="element-65" />
        </div>

        {/* Tomo 1 */}
        <div className="relative w-[88px] h-[156px] rounded-md shadow-xl transform -rotate-[6deg] overflow-hidden border border-stone-900/30 ring-1 ring-black/10" style={{
        zIndex: 3
      }} data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/n3qPFMRtFsY6kdgctvr7p2/TOMO_1_-_sahumerios.png" alt="Tomo 1 — La Ingeniería de la Masa" className="w-full h-full object-cover" data-id="element-67" />
        </div>

        {/* Tomo 2 — center, tallest */}
        <div className="relative w-[94px] h-[168px] rounded-md shadow-2xl overflow-hidden border border-stone-900/30 ring-1 ring-black/10 -mb-1" style={{
        zIndex: 4
      }} data-id="element-68">
          <img src="https://cdn.magicpatterns.com/uploads/bSL54LiDgvR4u9sjraoExe/TOMO_2_-_sahumerios.png" alt="Tomo 2 — Alquimia y Aromaterapia" className="w-full h-full object-cover" data-id="element-69" />
        </div>

        {/* Tomo 3 */}
        <div className="relative w-[88px] h-[156px] rounded-md shadow-xl transform rotate-[6deg] overflow-hidden border border-stone-900/30 ring-1 ring-black/10" style={{
        zIndex: 3
      }} data-id="element-70">
          <img src="https://cdn.magicpatterns.com/uploads/7posu7MFqCJez9YHSRoJmv/TOMO_3_-_sahumerios.png" alt="Tomo 3 — Negocio y Ventas 2026" className="w-full h-full object-cover" data-id="element-71" />
        </div>

        {/* Bono 2 — tucked behind right */}
        <div className="absolute -right-3 bottom-4 w-[60px] h-[108px] rounded-md shadow-lg transform rotate-[14deg] overflow-hidden border border-stone-900/30 ring-1 ring-black/10" style={{
        zIndex: 1
      }} data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/4wWm3LZYHbTG5xxhaqfmyX/BONO_2_-_sahumerio.png" alt="Bono 2 — Manual de Seguridad y Calidad" className="w-full h-full object-cover" data-id="element-73" />
        </div>
      </div>
    </div>;
}
export function ResultsScreen() {
  return <div className="flex flex-col min-h-screen bg-[#f4ebd0] text-stone-800 pb-12" data-id="element-74">
      {/* Header Banner */}
      <div className="bg-amber-900 text-white py-10 px-6 text-center rounded-b-[2.5rem] shadow-lg relative z-10 pt-[30px] pb-[30px]" data-id="element-75">
        <div className="inline-block px-3 py-1 bg-amber-800/60 border border-amber-700/50 rounded-full text-amber-200 text-[10px] font-bold tracking-widest uppercase mb-5" data-id="element-76">
          ✓ Análisis Completado
        </div>
        <h2 className="font-extrabold mb-4 text-amber-50 text-[26px]" data-id="element-77">
          Basado en tus respuestas, tenés todo lo que necesitás para empezar.
        </h2>
        <p className="text-amber-100/90 font-medium text-[13px]" data-id="element-78">
          No importa si nunca tocaste un sahumerio en tu vida. El Método Maestro
          fue diseñado exactamente para personas como vos: con ganas de
          emprender, sin experiencia previa y con materiales accesibles. Acá no
          hay magia ni promesas vacías. Hay un sistema paso a paso, probado, que
          te lleva desde la masa hasta tu primera venta real.
        </p>
      </div>

      <div className="max-w-md mx-auto w-full px-5 -mt-4 relative z-20 flex-grow flex flex-col" data-id="element-79">
        {/* Book stack visual */}
        <div className="bg-white rounded-3xl shadow-xl px-6 pt-6 pb-4 mb-5 border border-stone-200/60" data-id="element-80">
          <div className="text-center mb-1" data-id="element-81">
            <p className="text-[10px] font-extrabold tracking-widest text-amber-700 uppercase mb-0.5" data-id="element-82">
              Tu sistema completo
            </p>
            <p className="text-lg font-extrabold text-amber-950" data-id="element-83">
              3 Tomos + 2 Bonos
            </p>
          </div>
          <BookStack data-id="element-84" />
        </div>

        {/* What you receive section */}
        <div className="bg-amber-950 text-amber-50 rounded-2xl px-5 py-4 mb-5 shadow-lg flex items-center gap-3" data-id="element-85">
          <span className="text-2xl" data-id="element-86">📦</span>
          <div data-id="element-87">
            <p className="text-[10px] font-bold tracking-widest text-amber-300 uppercase" data-id="element-88">
              Lo que recibís hoy
            </p>
            <p className="text-base font-extrabold" data-id="element-89">
              Todo el sistema en detalle
            </p>
          </div>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-3 mb-6" data-id="element-90">
          {PRODUCTS.map(product => <div key={product.label} className="bg-white rounded-2xl p-5 shadow-sm border border-stone-200/60" data-id="element-91">
              <div className="flex items-center gap-3 mb-2" data-id="element-92">
                <span className="text-2xl" data-id="element-93">{product.icon}</span>
                <div className="flex items-center gap-2" data-id="element-94">
                  <span className={`w-2.5 h-2.5 rounded-full ${product.dotColor}`} data-id="element-95" />
                  <span className="text-[10px] font-extrabold tracking-widest text-stone-500 uppercase" data-id="element-96">
                    {product.label}
                  </span>
                </div>
              </div>
              <h3 className="text-base font-extrabold text-amber-950 mb-1.5 leading-tight" data-id="element-97">
                {product.title}
              </h3>
              <p className="text-sm text-stone-600 leading-relaxed" data-id="element-98">
                {product.description}
              </p>
            </div>)}
        </div>

        {/* Pricing card — highlighted */}
        <div className="relative mb-5 mt-4" data-id="element-99">
          {/* Glow background */}
          <div className="absolute -inset-1 bg-gradient-to-r from-amber-400 via-orange-400 to-amber-400 rounded-3xl blur-md opacity-50" data-id="element-100" />

          <div className="relative bg-white rounded-2xl pt-10 pb-6 px-6 shadow-2xl border-2 border-amber-400" data-id="element-101">
            {/* Full-width offer banner */}
            <div className="absolute -top-4 left-3 right-3 bg-gradient-to-r from-orange-500 via-amber-500 to-orange-500 text-white text-xs font-extrabold tracking-wider px-4 py-2.5 rounded-xl uppercase shadow-lg flex items-center justify-center gap-2" data-id="element-102">
              <span className="animate-pulse" data-id="element-103">⚡</span>
              <span data-id="element-104">Oferta de Lanzamiento · 50% OFF</span>
              <span className="animate-pulse" data-id="element-105">⚡</span>
            </div>

            <div className="text-center" data-id="element-106">
              <p className="text-[10px] font-bold tracking-widest text-stone-500 uppercase mb-2" data-id="element-107">
                Precio especial
              </p>
              <div className="flex items-center justify-center gap-2 mb-1" data-id="element-108">
                <span className="text-stone-400 text-lg font-semibold line-through" data-id="element-109">
                  $49.960
                </span>
                <span className="bg-red-100 text-red-700 text-[10px] font-extrabold px-1.5 py-0.5 rounded" data-id="element-110">
                  -50%
                </span>
              </div>
              <p className="text-5xl font-black text-amber-950 tracking-tight leading-none" data-id="element-111">
                $12.990
              </p>
              <p className="text-sm text-amber-800 font-bold mt-1 mb-4" data-id="element-112">
                ARS · Pago único
              </p>

              <div className="flex flex-wrap justify-center gap-x-3 gap-y-1.5 text-[11px] text-stone-700 font-semibold border-t border-amber-100 pt-3" data-id="element-113">
                <span className="flex items-center gap-1" data-id="element-114">
                  💳 3 cuotas sin interés
                </span>
                <span className="flex items-center gap-1" data-id="element-115">🔒 Pago seguro</span>
                <span className="flex items-center gap-1" data-id="element-116">
                  📩 Acceso en 5 min
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Urgency section */}
        <div className="bg-red-50 border border-red-200 rounded-2xl p-5 mb-5" data-id="element-117">
          <div className="flex justify-center mb-4" data-id="element-118">
            <CountdownTimer data-id="element-119" />
          </div>
          <p className="text-xs text-red-900 font-semibold leading-relaxed text-center mb-4" data-id="element-120">
            ⚠️ Este precio se termina cuando se completen los últimos cupos
            disponibles. Una vez cerrado el lanzamiento, el precio sube y no
            vuelve atrás.
          </p>

          <div className="bg-white rounded-xl p-3 shadow-inner" data-id="element-121">
            <div className="flex justify-between items-center mb-2" data-id="element-122">
              <span className="text-[11px] font-bold text-stone-700 uppercase tracking-wide" data-id="element-123">
                Cupos disponibles
              </span>
              <span className="text-[11px] font-bold text-red-600" data-id="element-124">
                Solo quedan unos pocos
              </span>
            </div>
            <div className="h-3 w-full bg-stone-200 rounded-full overflow-hidden" data-id="element-125">
              <div className="h-full bg-gradient-to-r from-red-500 to-red-600 rounded-full relative" style={{
              width: '80%'
            }} data-id="element-126">
                <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-127" />
              </div>
            </div>
            <p className="text-[10px] text-stone-500 mt-1.5 text-right font-medium" data-id="element-128">
              80% ocupado
            </p>
          </div>
        </div>

        {/* Main CTA */}
        <a href="https://www.recursohub.com/cart/48321691189440:1" target="_blank" rel="noopener noreferrer" className="w-full bg-amber-900 hover:bg-amber-950 text-white font-extrabold text-lg py-5 px-6 rounded-2xl shadow-[0_8px_30px_rgba(120,53,15,0.4)] transition-all transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2 mb-4 leading-tight" data-id="element-129">
          <span className="animate-pulse" data-id="element-130">🔴</span>
          <span data-id="element-131">SÍ, QUIERO VENDER MIS PRIMEROS SAHUMERIOS AHORA!!</span>
        </a>

        {/* Guarantee reassurance */}
        <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4 mb-5 flex items-start gap-3" data-id="element-132">
          <span className="text-2xl flex-shrink-0" data-id="element-133">🛡️</span>
          <p className="text-xs text-emerald-900 font-medium leading-relaxed" data-id="element-134">
            <span className="font-extrabold" data-id="element-135">Garantía total de 7 días.</span> Si
            en 7 días no es lo que esperabas, te devolvemos el 100% de tu
            dinero. Sin preguntas, sin formularios.
          </p>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap justify-center gap-x-3 gap-y-2 text-[11px] font-semibold text-stone-600 px-2" data-id="element-136">
          <div className="flex items-center gap-1" data-id="element-137">
            <span data-id="element-138">✅</span> Pago 100% seguro
          </div>
          <div className="flex items-center gap-1" data-id="element-139">
            <span data-id="element-140">⚡</span> Acceso en 5 min
          </div>
          <div className="flex items-center gap-1" data-id="element-141">
            <span data-id="element-142">🛡️</span> Garantía 7 días
          </div>
          <div className="flex items-center gap-1" data-id="element-143">
            <span data-id="element-144">💳</span> 3 cuotas sin interés
          </div>
          <div className="flex items-center gap-1" data-id="element-145">
            <span data-id="element-146">🇦🇷</span> Hecho en Argentina
          </div>
        </div>
      </div>
    </div>;
}